<template>
  <b-input-group>
    <date-picker
      v-model="date"
      :config="dateOptions"
      :required="required"
      @dp-hide="$emit('input', formatted(date))" />
    <b-input-group-append is-text>
      <span class="far fa-calendar" />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker"
import moment from "moment-timezone"

export default {
  name: "DateTimePicker",
  components: {
    datePicker,
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    timeZone: {
      type: String,
      default: null,
    },
    configOverride: {
      type: Object,
      default: null,
    },
    formatOverride: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      date: null,
      dateOptions: {},
    }
  },
  watch: {
    "configOverride.minDate": function(newVal) {
      this.dateOptions.minDate = newVal
      if (newVal) {
        const minDate = moment(newVal)
        if (minDate.isAfter(moment(this.date))) {
          this.date = minDate
        }
      }
    },
    "configOverride.maxDate": function(newVal) {
      this.dateOptions.maxDate = newVal
      if (newVal) {
        const maxDate = moment(newVal)
        if (maxDate.isBefore(moment(this.date))) {
          this.date = maxDate
        }
      }
    },
  },
  created() {
    const defaultOptions = {
      useCurrent: false,
      sideBySide: true,
    }

    if (this.timeZone) {
      defaultOptions.timeZone = this.timeZone
    }

    if (this.configOverride) {
      this.dateOptions = Object.assign(defaultOptions, this.configOverride)
    } else {
      this.dateOptions = defaultOptions
    }

    if (this.value) {
      this.date = moment(this.value)
    }
  },
  methods: {
    formatted(date) {
      // override the outgoing format. example: can be used to convert MM/DD/YYYY to RFC3339
      if (date && this.formatOverride) {
        const formatted = moment(date, this.dateOptions.format)
        return formatted.format(this.formatOverride)
      }
      return date
    },
  },
}
</script>